<template>
  <div>
    <v-row class="pa-12">
      <!--Splitting the screen-->
      <v-col md="6">
        <v-row>
          <v-col md="3" class="mr-8 pt-10">
             <v-list-item-avatar tile size="220" color="grey"></v-list-item-avatar>
          </v-col>
          <v-col md="8" class="mb-0 pb-0">
            <v-row v-for="item in dummyUser" :key="item.id">
              <v-col md="6">
                <v-text-field readonly label="Username" :value="item.Username"></v-text-field>
              </v-col>
              <v-col md="6" v-if="showGender == true">
                <v-text-field readonly label="Gender" :value="item.Gender"></v-text-field>
              </v-col>
              <v-col md="6" v-if="showName == true">
                <v-text-field readonly label="Name" :value="item.Name"></v-text-field>
              </v-col>
              <v-col md="6" v-if="showCountry == true">
                <v-text-field readonly label="Country" :value="item.Country"></v-text-field>
              </v-col>
              <v-col md="6" class="mb-0 pb-0" v-if="showName == true">
                <v-text-field readonly label="Last name" :value="item.Lastname"></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col md="12" class="pt-0 mt-0" v-for="item in dummyUser" :key="item.id">
            <v-textarea rows="" auto-grow dense label="About Me" readonly :value="item.Aboutme"></v-textarea>
          </v-col>
        </v-row>
      </v-col>
      <!--Section on right side (3 buttons)-->
      <v-col md="6" class="pr-12">
        <v-row>
          <v-col md="12">
            <v-row>
              <v-spacer></v-spacer>
              <v-btn color="primary">Follow</v-btn>
            </v-row>
          </v-col>
          <v-col md="12">
            <v-row>
              <v-spacer></v-spacer>
              <v-btn class="success">Send Message</v-btn>
            </v-row>
          </v-col>
          <v-col md="12">
            <v-row>
              <v-spacer></v-spacer>
              <v-btn class="error">Report</v-btn>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data(){
    return{
      showName:true,
      showCountry:false,
      showGender:false,
      dummyUser:[
        {id:1, Username:"Bob", Gender:"Submarine", Name:"Bob Bobby", Lastname:"Bobbensen", Country:"Land of no return", Aboutme:"I am BOB, and i like to dance!"}
      ]
    }
  }
}
</script>